import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layout/default/default.component';
import { DefaultBreadcumbComponent } from './layout/default-breadcumb/default-breadcumb.component';
import { OIDCSigninGuard } from './auth/guards/oidc-signin.guard';
import { FinalProcessComponent } from './endprocess/components/final-process/final-process.component';
import { FinalProcessGuard } from './endprocess/guards/final-process.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((mod) => mod.AuthModule)
  },
  {
    path: 'signin-oidc',
    canActivate: [OIDCSigninGuard],
    component: DefaultComponent
  },
  {
    path: 'end-process',
    component: FinalProcessComponent,
    loadChildren: () => import('./endprocess/endprocess.module').then((mod) => mod.EndProcessModule)
  },
  {
    path: 'dashboard',
    canActivate: [FinalProcessGuard],
    component: DefaultComponent,
    loadChildren: () => import('./dashboard/dashboard.module').then((mod) => mod.DashboardModule)
  },
  {
    path: 'itinerary',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./search-result/search-result.module').then((mod) => mod.SearchResultModule)
  },
  {
    path: 'voluntary-change',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./voluntary-change/voluntary-changes.module').then(
        (mod) => mod.VoluntaryChangesModule
      )
  },
  {
    path: 'cancellation',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./cancellation/cancellation.module').then((mod) => mod.CancellationModule)
  },
  {
    path: 'special-request',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./special-requests/special-requests.module').then((mod) => mod.SpecialRequestsModule)
  },
  {
    path: 'open-ticket',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./open-ticket/open-ticket.module').then((mod) => mod.OpenTicketModule)
  },
  {
    path: 'involuntary-change',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./involuntary-change/involuntary-change.module').then(
        (mod) => mod.InvoluntaryChangeModule
      )
  },
  {
    path: 'new-flow/:isException',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () =>
      import('./involuntary-change/involuntary-change.module').then(
        (mod) => mod.InvoluntaryChangeModule
      )
  },
  {
    path: 'integrations',
    canActivate: [FinalProcessGuard],
    loadChildren: () =>
      import('./integrations/integrations.module').then((mod) => mod.IntegrationsModule)
  },
  {
    path: 're-route',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () => import('./re-route/re-route.module').then((mod) => mod.ReRouteModule)
  },
  {
    path: 'reissue',
    canActivate: [FinalProcessGuard],
    component: DefaultBreadcumbComponent,
    loadChildren: () => import('./reissue/reissue.module').then((mod) => mod.ReissueModule)
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
